import styled from "styled-components/macro";
import { focusVisibleInset } from "../../../styles/a11y";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  &.disable {
    opacity: 0.5;
  }

  .tabs-container {
    margin-bottom: 12px;
    display: flex;
    justify-content: flex-start;
  }

  .subtitle {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.3;
    color: var(--grey-1);
    text-align: left;
    margin: 0 0 16px 0;
  }

  .instructions {
    margin-bottom: 16px;
    text-align: left;

    h4 {
      margin: 0 0 8px 0;
      font-size: 14px;
      font-weight: 600;
      color: var(--grey-0);
    }

    ol {
      margin: 0;
      padding-left: 20px;

      li {
        margin-bottom: 4px;
        font-size: 13px;
        color: var(--grey-1);
        line-height: 1.4;

        &:last-child {
          margin-bottom: 0;
        }

        strong {
          color: var(--grey-0);
        }
      }
    }
  }

  .upload {
    height: 100%;
    min-height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: var(--grey-0);
    background-color: var(--container-color);
    border: 1.5px dashed var(--grey-2);
    border-radius: 6px;
    transition: background 200ms ease-in-out;
    cursor: pointer;

    &:hover {
      background-color: var(--grey-3);
    }

    ${focusVisibleInset}
  }

  .import-icon {
    box-sizing: border-box;
    height: 38px;
    width: 36px;
    padding: 9px 8px 9px 8px;

    path {
      stroke: var(--grey-0);
    }
  }

  p {
    font-family: "Inter";
    font-weight: 500;
  }

  .drag-title {
    margin-top: 8px;
    font-size: 14px;
  }

  .supported-format {
    margin-top: 12px;
    font-size: 12px;
    color: var(--grey-1);
  }

  .upload-link {
    margin-top: 10px;
    font-size: 13px;
  }

  a {
    color: var(--grey-0);
    text-decoration: underline;
  }

  .rejected {
    border-color: var(--danger-color);
    background-color: rgba(255, 88, 98, 0.1);
  }

  .accepted {
    border-color: var(--primary-cta-high-contrast);
    background-color: var(--primary-cta-transparent-15);
  }
`;
